import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../../components/Buttons/Button";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import { getUserRolePermissions } from '../../../services/userServicer';
import Select from 'react-select';
import { getControls } from "src/services/controls";
import { fetchAllCategoryDataApi, fetchAllDataApi } from "src/services/riskServices";
import { useForm } from "react-hook-form";
import { MdOutlineDelete } from "react-icons/md";
import { createQuestion } from "src/services/question"
import { useNavigate } from 'react-router-dom';

import { getReferences, getReferencesInCompliance } from "src/services/reference";
import LoadingScreen from "../../../components/Loading/LoadingScreen";
const CreateQuestionPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notAllowed, setNotAllowed] = useState(false);
  const [userPermissions, setUserPermissions] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [referenceOptions, setReferenceOptions] = useState<any[]>([]);

  const { register, handleSubmit, formState: { errors }, watch, setValue, trigger } = useForm();
  const [question, setQuestion] = useState<{
    en_questionText: string;
    ar_questionText: string;
    type: string;
    options: string[];
    risk: string;
    control: string;
    category: string;
    referenceId: string;
  }>({
    en_questionText: '',
    ar_questionText: '',
    type: '',
    options: [] as string[],
    risk: '',
    control: '',
    category: '',
    referenceId: '',
  });
  const [references, setReferences] = useState<any[]>([{ reference: null,points: [{label:"",value:""}],selectedpoints: [{ point: null, controls: [] }] }]);


  const handleReferenceChange = (index: number, selectedOption: any) => {
    
    const newReferences = [...references];
    newReferences[index].reference = selectedOption;
  //  newReferences[index].points = pointsData;
    setReferences(newReferences);
};
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setQuestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOptionChange = (index: number, value: string) => {
    const updatedOptions = [...question.options];
    updatedOptions[index] = value;
    setQuestion((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  };

  const addOption = () => {
    setQuestion((prev) => ({
      ...prev,
      options: [...prev.options, ''],
    }));
  };

  const removeOption = (index: number) => {
    const updatedOptions = question.options.filter((_, i) => i !== index);
    setQuestion((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  };

  const onSubmit = async(data: any) => {
    if(question.type === 'compliance_related'){
      question.options = ['Fully Implemented','Implemented','Mostly Implemented','Partially Implemented','Averagely Implemented', 'Not Implemented']
    }
    if(question.type === 'risk_related'){
      question.options = ['Least','Minimal','Moderate','Significant','Most']
    }
    if(question.en_questionText !== ''){
      question.ar_questionText = question.en_questionText
    }
    // Extract reference_id as a string
    question.referenceId = references[0]?.reference?.value || '';
    const response = await createQuestion(question);
    if (response.success) {
      toast.success(response.message);
      navigate('/bankQuestions');
    } else {
      toast.error(response.message);
    }
    
  };

  const [controlsOptions, setControlsOptions] = useState<any[]>([]);
  const [riskOptions, setRiskOptions] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);

  const fetchControls = async () => {
    try {
      const controls: any = await getControls();
      
      if (controls?.data && controls?.data?.length > 0) {
        let controlsOptions = controls?.data?.map((control: any) => ({
          value: control.id,
          label: control.description
        }));
        setControlsOptions(controlsOptions);
      } else {
        toast.error('No controls found');
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const fetchRisks = async () => {
    try {
      const risks: any = await fetchAllDataApi();
      
      if (risks.data && risks.data.length > 0) {
        let risksOptions = risks.data.map((risk: any) => ({
          value: risk.id,
          label: risk?.name
        }));
        setRiskOptions(risksOptions);
      } else {
        toast.error('No risks found');
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await fetchAllCategoryDataApi();
      if (response.success && Array.isArray(response.data)) {
        setCategories(response.data);
      } else {
        //console.log("Invalid data format for categories");
      }
    } catch (error) {
      toast.error(t("Failed to fetch categories"));
      setCategories([]);
    }
  };

  useEffect(() => {
    const fetchUserRolePermissions = async () => {
      try {
        //let userId: any = localStorage.getItem('userId');
        const permissions = await getUserRolePermissions();
        if (permissions.success) {
          const compliancePagePermission = permissions.data.permissions.find((permission: any) => permission.page === "survey");
          if (compliancePagePermission) {
            setUserPermissions(compliancePagePermission);
            if (compliancePagePermission?.permissions?.create) {
              setNotAllowed(false);
            } else {
              setNotAllowed(true);
            }
          } else {
            toast.error(permissions.message);
          }
        }
      } catch (error: any) {
        toast.error(t("permissions.Error_fetching_user_role_permissions") + ":", error);
      }
    };

    const fetchReferences = async () => {
      try {
          const data = await getReferences('', 500, 0);
         
          if(data && data.success){
         
          const options = data?.data?.map((ref: any) => ({ value: ref.id, label: ref.name }));
          
          setReferenceOptions(options);
          }
          else{
              toast.error(data[0].message, { autoClose: 5000, className: 'toast-error' });
          }
      } catch (error:any) {
          toast.error(error, { autoClose: 5000, className: 'toast-error' });
          console.error('Error fetching references:', error);
      }
  };

    const fetchData = async () => {
      await fetchUserRolePermissions();
      await fetchControls();
      await fetchRisks();
      await fetchCategories();
      await fetchReferences();
      setLoading(false);
    };

    fetchData();
  }, []);

  // Custom styles for react-select to reduce height
  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '50px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '40px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '40px',
    }),
  };

  if (loading) {
    return (
      <div className="loading-screen" 
      style={{ 
        backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
                     <div><LoadingScreen/></div>
                   </div>
    );
  }

  if (!loading) {

  return (
    <div className="root">
      <Breadcrumb>
        <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
        <BreadcrumbItem>{t("Questions")}</BreadcrumbItem>
        <BreadcrumbItem active style={{ paddingRight: '10px' }}>
          {t("Create_question")}
        </BreadcrumbItem>
      </Breadcrumb>

      <h5 className="mb-lg">{t('Create_question')}</h5>
      {
        !notAllowed && <div className="container_info">
          <form onSubmit={handleSubmit(onSubmit)} className="create-compliance-form">
            <div className="form-section2 mb-5">
              <h5 className="section-title">{t('BasicInfo')}</h5>

          
              <div className="form-group">
                <label>question</label>
                <input
                  type="text"
                  value={question.en_questionText}
                  
                  className="form-control"
                  {...register("en_questionText", { required: true })}
                  onChange={handleInputChange}
                />
                {errors.en_questionText && <span className="text-danger">{t('This field is required')}</span>}
              </div>
              {/*<div className="form-group">
                <label>question (Arabic)</label>
                <input
                  type="text"
                  value={question.ar_questionText}
                
                  className="form-control"
                  {...register("ar_questionText", { required: true })}
                  onChange={handleInputChange}
                />
                {errors.ar_questionText && <span className="text-danger">{t('This field is required')}</span>}
              </div>*/}

              {/* Category Dropdown */}
              <div className="form-group">
                <label htmlFor="category">{t("Category")}</label>
                <select
                  id="category"
                  style={{height: '40px',padding: '0px 10px'}}
                  className={`form-control ${errors.category ? "is-invalid" : ""}`}
                  {...register("category", { required: t("Category is required") ?? "Category is required" })}
                  onChange={handleInputChange}
                >
                  <option value="">{t("Select Category")}</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category?.name}
                    </option>
                  ))}
                </select>
                {errors.category?.message && (
                  <div className="invalid-feedback">
                    {String(errors.category.message)}
                  </div>
                )}
              </div>


              <div className="form-group">
  <label>References</label>
  {references.map((reference, refIndex) => (
                <div className="form-group" key={refIndex} style={{ flex: '1 1 80%' }}>

<Select
        name={`reference-${refIndex}`}
        options={referenceOptions}
        className="basic-single"
        classNamePrefix="select"
        onChange={(selectedOption) => handleReferenceChange(refIndex, selectedOption)}
        styles={customSelectStyles}
        value={reference.reference}
      />
   
    </div>
  ))}

</div>

              <div className="form-group">
                <label className="form-label">{t("Type")}</label>
                <Select
                  options={[
                    { value: 'textarea', label: t("Text") },
                    { value: 'multiple_choice', label: t("Multiple Choice") },
                    { value: 'single_choice', label: t("Single Choice") },
                      { value:'compliance_related', label:t('Related to compliance')},
                      { value:'risk_related', label:t('Related to risk')}
                  ]}

                  
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customSelectStyles}
                  onChange={(selectedOption: any) => {
                    const value = selectedOption ? selectedOption.value : '';
                    setQuestion((prev) => ({
                      ...prev,
                      type: value
                    }));
                    setValue("type", value);
                    trigger("type");
                  }}
                />
                {errors.type && <span className="text-danger">{t('This field is required')}</span>}
              </div>

             
              {(question.type === "multiple_choice" || question.type === "single_choice" )&& (
                <div className="form-group">
                  <label className="form-label">{t("Options")}</label>
                  <button
                    type="button"
                    onClick={addOption}
                    className="btn btn-warning mr-2 ml-2"
                  >
                   + {t("Add Option")}
                  </button>
                  {question.options.map((option, index) => (
                    <div key={index} className="d-flex flex-row mt-2">
                      <input
                        type="text"
                        value={option}
                        onChange={(e) => handleOptionChange(index, e.target.value)}
                        className="form-control"
                        placeholder={`Option ${index + 1}`}
                        required
                      />
                      
                      <button
                        type="button"
                        onClick={() => removeOption(index)}
                        className="action-button-danger"
                      >
                         <MdOutlineDelete size={20} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="form-section2 mb-5" style={{display:question.type === 'compliance_related' || question.type === 'risk_related' ? 'block' : 'none'}}>
              <h5 className="section-title">{t('Related To')}</h5>

              <div className="form-group" style={{display:question.type === 'compliance_related' ? 'block' : 'none'}}>
                <label className="form-label">{t("Control")}</label>
                <Select
                  options={controlsOptions}
                  isMulti={true}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customSelectStyles}
                  {...register("control")}
                  onChange={(selectedOptions: any) => {
                    setQuestion((prev) => ({
                      ...prev,
                      control: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                    }));
                    setValue("control", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                    trigger("control");
                  }}
                />
              </div>
              

              <div className="form-group" style={{display:question.type === 'risk_related' ? 'block' : 'none'}}>
                <label className="form-label">{t("Risk")}</label>
                <Select
                  options={riskOptions}
                  isMulti={true}
                  className="basic-single"
                  classNamePrefix="select"
                  styles={customSelectStyles}
                  {...register("risk")}
                  onChange={(selectedOptions: any) => {
                    setQuestion((prev) => ({
                      ...prev,
                      risk: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                    }));
                    setValue("risk", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                    trigger("risk");
                  }}
                />
              </div>


          
           
            </div>

       <button type="submit" className="submit-button4" style={{marginBottom: '20px'}}>
                {t("Create Question")}
              </button>
          </form>
        </div>
      }

      {notAllowed && <div className="container_info">
        <div className="d-flex justify-content-between my-2 text-center alert alert-danger">
          <h5 style={{ width: '100%' }} className="text-center">{t("permissions.not_allowed")}</h5>
        </div>
      </div>}
    </div>
  );
}
};

export default CreateQuestionPage;